import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { MDSModal } from "@/mds";
import { ImportStatus } from "@/store/one-click-import/types";
import type { FC } from "react";
import { OneClickImportContent } from "./one-click-import-content";

/**
 * OneClickImportModal is the standalone modal for importing notes from Apple Notes.
 * It wraps OneClickImportContent with MDSModal.
 *
 * This modal is used for the non-onboarding entry point (profile menu).
 * For the onboarding wizard, use OneClickImportStep instead.
 */
export const OneClickImportModal: FC = observer(function OneClickImportModal() {
  const { store } = useAppStore();

  const isModalOpen = store.oneClickImport.isModalOpen;
  const entryPoint = store.oneClickImport.entryPoint ?? "profile_menu";

  const handleClose = () => {
    store.oneClickImport.closeModal({ status: ImportStatus.Failed });
  };

  const handleImportSuccess = () => {
    store.oneClickImport.closeModal({ status: ImportStatus.Success });
  };

  const handleCancel = () => {
    store.oneClickImport.closeModal({ status: ImportStatus.Failed });
  };

  return (
    <MDSModal isOpen={isModalOpen} handleClose={handleClose} isDismissable={false}>
      <OneClickImportContent
        onImportSuccess={handleImportSuccess}
        onCancel={handleCancel}
        entryPoint={entryPoint}
        showCancelButton={false}
      />
    </MDSModal>
  );
});
